module.exports = __webpack_public_path__ + "img/pool.6e04b7c6.jpg";